import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import React from 'react';
import dynamic from 'next/dynamic';
import { AdminGuard } from '@techstyle/react-admin';
import featuresModule, { loadFeatures } from './featuresModule';
import logger from './logger';
var debug = logger.extend('featuresExtension');
var FeaturesAdminPanel = dynamic(() => import(
/* webpackChunkName: "AdminTools" */
'./FeaturesAdminPanel'));
export default function featuresExtension() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      globalPrefetchFeatures = _ref.globalPrefetchFeatures;

  return registry => ({
    id: 'features',
    redux: {
      modules: [featuresModule]
    },
    server: process.browser ? undefined : {
      init() {
        require('./config');
      }

    },
    app: {
      render(props, children) {
        return /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(AdminGuard, null, /*#__PURE__*/React.createElement(FeaturesAdminPanel, null)));
      }

    },

    page(_ref2) {
      var _ref2$prefetchFeature = _ref2.prefetchFeatures,
          prefetchFeatures = _ref2$prefetchFeature === void 0 ? [] : _ref2$prefetchFeature;
      var getFeatures = registry.utils.getMergedArrayOption({
        globalPrefetchFeatures,
        prefetchFeatures
      });
      return {
        getInitialProps(ctx) {
          return _asyncToGenerator(function* () {
            var _yield$getFeatures = yield getFeatures(ctx),
                _yield$getFeatures2 = _slicedToArray(_yield$getFeatures, 2),
                features = _yield$getFeatures2[0],
                meta = _yield$getFeatures2[1];

            if (features.length) {
              debug('Loading %s %s added by %s.', features.length, features.length === 1 ? 'feature' : 'features', meta.sources.join(', '));
              yield ctx.store.dispatch(loadFeatures(features));
            }
          })();
        }

      };
    }

  });
}